import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadProfessor, saveProfessor } from "../../lib/api/professor";
import { ProfessorEditForm } from "../../components/professor/ProfessorEditForm";
import { EmptyBlank } from "../../components/common";

const Edit = () => {
  const { id } = useParams();
  const [professor, setProfessor] = useState();

  const requestLoadProfessor = useCallback(async () => {
    const { data } = await loadProfessor({ id: id });
    //console.log(data);
    setProfessor(data);
  }, [id]);

  useEffect(() => {
    requestLoadProfessor();
  }, [requestLoadProfessor]);

  const handleSaveWeek = ({ weekId, weekState, weekAuth }) => {
    //console.log("handleSaveWeek => ", weekId, weekState, weekAuth);
    saveProfessor({ id, weekId, weekState, weekAuth });
  };

  return (
    <div>
      <Container fluid="md">
        {professor ? (
          <ProfessorEditForm
            professor={professor}
            handleSaveWeek={handleSaveWeek}
          />
        ) : undefined}
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default Edit;
